(function () {
  document.querySelectorAll('[data-filter]').forEach(function (root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-chip]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-tags]'));
    var sensBtn = root.querySelector('[data-sens-toggle]');
    var countEl = root.querySelector('[data-count]');
    var one = root.getAttribute('data-one') || '';
    var many = root.getAttribute('data-many') || '';
    var cur = 'alle', sens = false;
    chips.forEach(function (c) { c.setAttribute('data-label', c.textContent.trim()); });
    function has(it, k) {
      return k === 'alle' || (' ' + it.getAttribute('data-tags') + ' ').indexOf(' ' + k + ' ') > -1;
    }
    function okSens(it) { return !sens || it.getAttribute('data-sens') === '1'; }
    function render() {
      var shown = 0;
      items.forEach(function (it) {
        var on = has(it, cur) && okSens(it);
        it.classList.toggle('is-hidden', !on);
        if (on) shown++;
      });
      chips.forEach(function (c) {
        var k = c.getAttribute('data-chip');
        var n = items.filter(function (it) { return has(it, k) && okSens(it); }).length;
        c.textContent = c.getAttribute('data-label') + ' (' + n + ')';
        c.setAttribute('aria-pressed', k === cur ? 'true' : 'false');
      });
      if (sensBtn) sensBtn.setAttribute('aria-pressed', sens ? 'true' : 'false');
      if (countEl) countEl.textContent = shown + ' ' + (shown === 1 ? one : many);
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () { cur = c.getAttribute('data-chip'); render(); });
    });
    if (sensBtn) sensBtn.addEventListener('click', function () { sens = !sens; render(); });
    render();
  });
})();

/* HubSpot: copy of the test request to CRM (portal 149635914, form "BOH Testanfrage").
   Does not block the normal Shopify submission; keepalive lets the request finish during navigation. */
(function () {
  var form = document.getElementById('test-form');
  if (!form || !window.fetch) return;
  var URL = 'https://api.hsforms.com/submissions/v3/integration/submit/149635914/7980ab58-9f4b-4d07-8e30-ea7aac281089';
  var FL = { 'bis 80 m²': 'bis_80', '80–250 m²': '80_250', '250–600 m²': '250_600', 'über 600 m²': 'ueber_600' };
  var AN = { 'Kostenlosen Test vereinbaren': 'test', 'Rückruf mit Preisangebot': 'rueckruf', 'Beratung vor Ort': 'beratung' };
  var sent = false;
  function v(n) { var el = form.elements['contact[' + n + ']']; return el && el.value ? String(el.value).trim() : ''; }
  function cookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? m[1] : ''; }
  form.addEventListener('submit', function () {
    if (sent || !v('email')) return;
    sent = true;
    try {
      var name = v('name').split(/\s+/), first = name.shift() || '', last = name.join(' ');
      var fields = [
        ['email', v('email')], ['firstname', first], ['lastname', last], ['phone', v('phone')],
        ['company', v('Firma')], ['zip', v('PLZ')], ['industry', v('Branche')],
        ['boh_flaeche', FL[v('Fläche')] || ''], ['boh_anliegen', AN[v('Anliegen')] || ''],
        ['boh_quelle_seite', v('Seite') || location.href]
      ].filter(function (f) { return f[1]; }).map(function (f) { return { name: f[0], value: f[1] }; });
      var ctx = { pageUri: location.href, pageName: document.title };
      var h = cookie('hubspotutk'); if (h) ctx.hutk = h;
      fetch(URL, {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fields: fields, context: ctx })
      }).catch(function () {});
    } catch (err) {}
  });
})();
